import _get from 'lodash/get'
import _merge from 'lodash/merge'

import Store from '../StoreCollection.js'

let ConstantsCollection = {}

_merge(ConstantsCollection, Store, {
  state: {
    apiBaseUrl: '/api/v1/constants',
    collection: _get(window, 'appInitialData.stores.Constants', null)
  }
})

export default ConstantsCollection
